import type { FC } from 'react';
import './StarIcon.css';

interface iStartIcon {
  fill: string;
}

const StarIcon: FC<iStartIcon> = ({ fill }) => {
  return (
    <svg
      className="star-icon"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          'M12.4004 3.67264L14.8899 9.16165L20.5973 9.67367C20.6812 9.68197 20.7611 9.7139 20.8275 ' +
          '9.76576C20.894 9.81763 20.9444 9.88727 20.9728 9.96664C21.0013 10.046 21.0067 10.1318 ' +
          '20.9883 10.2141C20.97 10.2964 20.9286 10.3718 20.8691 10.4315L16.6787 14.6094L17.729 ' +
          '20.0579C17.7452 20.1391 17.7382 20.2233 17.7089 20.3007C17.6796 20.3782 17.6291 ' +
          '20.4459 17.5632 20.4961C17.4973 20.5463 17.4187 20.577 17.3362 20.5846C17.2538 ' +
          '20.5923 17.1708 20.5767 17.0967 20.5395L12.0002 17.9665L6.90288 20.5184C6.82881 ' +
          '20.5552 6.74595 20.5704 6.66365 20.5625C6.58136 20.5546 6.50297 20.5238 6.43729 ' +
          '20.4736C6.37161 20.4233 6.32126 20.3557 6.29202 20.2784C6.26277 20.2011 6.25582 ' +
          '20.1171 6.27184 20.036L7.32169 14.6134L3.12894 10.4291C3.06942 10.3694 3.02802 ' +
          '10.2939 3.00967 10.2116C2.99132 10.1293 2.99679 10.0434 3.0253 9.96407C3.05381 ' +
          '9.88469 3.10423 9.81503 3.17077 9.76319C3.2373 9.71135 3.31715 9.67945 3.40109 ' +
          '9.67122L9.10887 9.15923L11.5984 3.6702C11.6338 3.59351 11.6905 3.52862 11.7618 ' +
          '3.48322C11.833 3.43781 11.9157 3.41381 12.0002 3.41406C12.0847 3.41432 12.1673 ' +
          '3.43884 12.2382 3.48467C12.3092 3.53051 12.3655 3.59575 12.4004 3.67264Z'
        }
        fill={fill}
      />
    </svg>
  );
};

export default StarIcon;
